module.exports = __webpack_public_path__ + "static/media/logo_adelante_andalucia.1854d4a1.svg";